import React from 'react';
import { motion } from 'framer-motion';

// පින්තූර මෙතනට එකතු කරන්න. size එක අනුව Grid එක වෙනස් වෙනවා.
const galleryImages = [
  { id: 1, src: '/assets/prize-giving.jpg', title: 'Annual Prize Giving', size: 'md:col-span-2 md:row-span-2' },
  { id: 2, src: '/assets/sports-night.jpg', title: 'Sports Meet', size: 'md:col-span-1 md:row-span-1' },
  { id: 3, src: '/assets/science-day.jpg', title: 'Science Day Exhibition', size: 'md:col-span-1 md:row-span-1' },
  { id: 4, src: '/assets/other1.jpg', title: 'Dancing Fest', size: 'md:col-span-1 md:row-span-2' },
  { id: 5, src: '/assets/logo1.png', title: 'Extra Activities', size: 'md:col-span-1 md:row-span-1' },
  { id: 6, src: '/assets/event-new.jpg', title: 'Religious Program', size: 'md:col-span-2 md:row-span-1' },
];

const GalleryModal = ({ onClose }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, scale: 1.1 }} 
      animate={{ opacity: 1, scale: 1 }} 
      exit={{ opacity: 0, scale: 1.1 }}
      className="fixed inset-0 z-[10001] bg-white overflow-y-auto font-sans"
    >
      {/* --- MODAL NAVBAR --- */}
      <div className="sticky top-0 z-[100] bg-white/90 backdrop-blur-xl px-6 md:px-12 py-6 flex justify-between items-center border-b border-slate-100">
        <div>
          <h2 className="text-2xl md:text-3xl font-black text-indigo-950 tracking-tighter uppercase leading-none">
            VIDULAKA <span className="text-red-600">ARCHIVES</span>
          </h2>
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.4em] mt-2">Institutional Memories & Highlights</p>
        </div>
        
        <button 
          onClick={onClose}
          className="group flex items-center gap-3 bg-indigo-950 text-white px-6 py-3 rounded-full hover:bg-red-600 transition-all duration-500 shadow-xl active:scale-90"
        >
          <span className="text-[10px] font-black uppercase tracking-widest hidden md:block">Close Gallery</span>
          <span className="text-xl">✕</span>
        </button>
      </div>

      {/* --- MASONRY GRID --- */}
      <div className="max-w-7xl mx-auto p-6 md:p-12">
        <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[250px] gap-6">
          {galleryImages.map((img, index) => (
            <motion.div
              key={img.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className={`relative group overflow-hidden bg-slate-100 rounded-3xl ${img.size}`}
            >
              <img 
                src={img.src} 
                alt={img.title} 
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-[1s] group-hover:scale-110" 
              />
              
              {/* Image Info on Hover */}
              <div className="absolute inset-0 bg-gradient-to-t from-indigo-950/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-8">
                <span className="text-red-500 text-[10px] font-black uppercase tracking-widest mb-1">Event Collection</span>
                <p className="text-white font-black uppercase text-lg tracking-tight leading-none">{img.title}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* --- FOOTER --- */}
        <div className="mt-20 py-16 border-t border-slate-100 text-center">
          <p className="text-[10px] font-black text-slate-300 uppercase tracking-[0.6em]">
            © 2026 Vidulaka Matale Campus • Powered by Smart Class
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default GalleryModal;